module.exports = __webpack_public_path__ + "img/face-weary.0a452440.svg";